import React, { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

import Navbar from 'components/mobile/Navbar'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.custom.mobileNavBarHeight + 24}px 16px 16px`,
  },
}))

const MainMobileWrapper = ({ children = null }: { children?: ReactNode }) => {
  const classes = useStyles()

  return (
    <Grid>
      <Navbar />
      <Grid className={classes.root}>{children ?? <Outlet />}</Grid>
    </Grid>
  )
}

export default MainMobileWrapper
